import Cookie from 'js-cookie'

export default {
    getAdsAnalyticsCookieObject: function () {

        let result = {};

        const cookie = Cookie.get('adsa');

        if (cookie) {
            try {
                const decodedValue = atob(cookie);
                result = JSON.parse(decodedValue);
            } catch {
                console.log("VFP: psr: ADSA Cookie invalid");
            }
        }

        return result;

    },
    getPardotVisitorCookieValues: function () {
        let result = {};

        let cookies = Cookie.get();
        if (cookies) {
            let visitorCookieKeys = Object.getOwnPropertyNames(cookies).filter(x => x.startsWith('visitor_id') && !x.includes('hash'));
            for (const i in visitorCookieKeys) {
                const key = visitorCookieKeys[i];
                result[key] = cookies[key];
            }
        }
        return result;
    },
    getCurrentUserId: function () {
        // Initialize the URL of the API endpoint
        const url = '/site-api/account/getuserinfo';

        // Use fetch to call the API
        return fetch(url)
            .then(response => {
                // Check if the response is ok (status in the range 200-299)
                if (!response.ok) {
                    // If not, throw an error to skip to the catch block
                    throw new Error('Network response was not ok');
                }
                // If the response is ok, try to parse it as JSON
                return response.json();
            })
            .then(data => {
                // If JSON parsing is successful, return the Id value
                // Check if the data object has an Id property to avoid potential errors
                if (data && typeof data.Id === 'string') {
                    return data.Id;
                }
                // If the data object doesn't have an Id property, return an empty string
                return '';
            })
            .catch(error => {
                // In case of any error (network or parsing), log the error and return an empty string
                console.error('VFP: psr: Failed to check for currently logged in user:', error);
                return '';
            });
    }
}